module.exports = __webpack_public_path__ + "img/logo.bd195430.png";